module.exports = __webpack_public_path__ + "img/dd_bg.942e4dd1.jpg";